import { ArrowLeft, Loader2, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

export function AdminHeader({ onBack, reordering, onLogout }) {
  return (
    <header className="bg-[#1aa59a] sticky top-0 z-40 shadow-md">
      <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={onBack}
            className="text-white hover:bg-white/10"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div className="text-white">
            <h1 className="text-lg font-bold">Admin Panel</h1>
            <p className="text-xs text-white/80">Manage your menu</p>
          </div>
        </div>
        {reordering && (
          <div className="flex items-center gap-2 text-white text-sm">
            <Loader2 className="w-4 h-4 animate-spin" />
            Saving...
          </div>
        )}
        <Button
          variant="ghost"
          size="sm"
          onClick={onLogout}
          className="text-white hover:bg-white/10 ml-auto"
          data-testid="admin-logout"
        >
          <LogOut className="w-4 h-4 mr-1" /> Log out
        </Button>
      </div>
    </header>
  );
}
